import { Component, inject, OnInit } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import blogJson from '../../../assets/blog.json';
import { BlogHeroComponent } from '@components/blog-hero/blog-hero.component';
import { BlogCardComponent } from '@components/cards/blog-card/blog-card.component';
import { BlogService } from '@core/services/blog/blog.service';
@Component({
  selector: 'ln-blog',
  imports: [LnPagesArmorComponent, BlogHeroComponent, BlogCardComponent],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.css',
})
export class BlogComponent implements OnInit {
  ngOnInit(): void {
    this.blogService.getArticles().subscribe(articles => {
      //console.log(articles);
    });
  }
  // @ViewChild('injectBlog', { static: false })
  // injectBlog!: ElementRef<HTMLDivElement>;
  // private htmlCode = blogJson.data.htmlContent;
  protected articles = blogJson.data.articles;
  private blogService = inject(BlogService);
  // private cssCode = blogJson.data.styles;
  // private render = inject(Renderer2);
  // private sanitizer = inject(DomSanitizer);
  // private injectBlogCSS?: HTMLStyleElement;

  // ngAfterViewInit(): void {
  //   // this.render.setProperty(this.injectBlog.nativeElement, 'innerHTML', this.htmlCode);
  //   // this.injectHTML();
  // }

  // injectHTML() {
  //   const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, this.htmlCode) ?? '';
  //   this.render.setProperty(this.injectBlog.nativeElement, 'innerHTML', sanitized);
  //   //
  //   // const css = this.scopeCss(this.cssCode, '.injectBlogCSS');
  //   // this.injectBlogCSS ??= this.render.createElement('style');
  //   // this.injectBlogCSS!.textContent = css;
  //   // this.injectBlog.nativeElement.appendChild(this.injectBlogCSS!);
  // }

  // private scopeCss(css: string, scope: string): string {
  //   return css.replace(
  //     /(^|})\s*([^{@}][^{]*)\{/g,
  //     (_m, sep, sel) =>
  //       `${sep}\n${sel
  //         .split(',')
  //         .map((s: string) => `${scope} ${s.trim()}`)
  //         .join(', ')}{`
  //   );
  // }
}
